import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { RespuestaModel } from '../models/respuesta.model';
import { environment } from 'src/environments/environment';


@Injectable({
  providedIn: 'root'
})
export class MainService {
  /*
  // url_renapo = 'https://wsrenapo.conade.gob.mx/';
  // gatewayServiciosEnedPreRegistro  = 'http://10.10.0.175:8428/';
  // gatewayServiciosEnedPreRegistroAdministracion  = 'http://10.10.0.32:9071/';
  gatewayFormularioDinamico = 'http://10.10.0.32:8056/';
  gatawayArchivos = 'http://10.10.0.32:8065/'
  gatewayCargaMasiva = 'http://10.10.0.32:8056/';
  gatewayAspirantes = 'http://10.10.0.32:8056/';
  gatewayCatalogos = 'http://10.10.0.32:8056/';
  gatewayDocentes = 'http://10.10.0.32:8056/';
  //gatewayFormularioDinamico = 'https://localhost:7217/'
  urlServicioControlEscolar = 'https://localhost:7243/';
  //urlServicioControlEscolar ='http://10.10.0.32:8056/Servicios/'
  //
  */
  //servicesOIC = "http://198.251.71.105:8081/";
  //servicesOIC = "https://localhost:44325/";
  // servicesOIC = "https://oicapi.conade.gob.mx/";
  servicesOIC = environment.apiUrl;

  //servicesOIC = "http://198.251.71.105:8088/";
  //archivosOIC = "http://198.251.71.105:90/"
  //servicesOIC = "http://10.10.0.32:8011/";
  archivosOIC = "https://adminarchivos.conade.gob.mx/";
  constructor(public httpClient: HttpClient) { }
  getAsync(url: string): Promise<any> {
    return new Promise(resolve => {
      const subscription = this.httpClient.get<any>(url)
        .subscribe(
          data => {
            subscription.unsubscribe();
            resolve(data);

          }, error => {
            subscription.unsubscribe();
            resolve({
              EXITO: false,
              MENSAJE: error.message.toString(),
              RESPUESTA: error.error.text
            } as RespuestaModel);
          });
    });
  }

  postAsync(url: string, objeto: any): Promise<any> {

    return new Promise(resolve => {

      const subscription = this.httpClient.post(url, objeto)
        .subscribe(
          data => {

            subscription.unsubscribe();

            resolve(data ? data : { EXITO: true } as RespuestaModel);
          },
          error => {

            subscription.unsubscribe();

            return resolve({
              EXITO: false,
              MENSAJE: error.message.toString(),
              RESPUESTA: null
            } as RespuestaModel);
          });
    });
  }

  putAsync(url: string, objeto: any): Promise<any> {
    return new Promise(resolve => {
      const subscription = this.httpClient.put(url, objeto)
        .subscribe(
          data => {

            subscription.unsubscribe();

            resolve(data ? data : { EXITO: true } as RespuestaModel);
          },
          error => {

            subscription.unsubscribe();

            return resolve({
              EXITO: false,
              MENSAJE: error.message.toString(),
              RESPUESTA: null
            } as RespuestaModel);
          });
    });
  }

  deleteAsync(url: string): Promise<any> {

    return new Promise(resolve => {

      const subscription = this.httpClient.delete<any>(url)
        .subscribe(
          data => {

            subscription.unsubscribe();

            resolve(data ? data : { EXITO: true } as RespuestaModel);

          }, error => {

            subscription.unsubscribe();

            resolve({
              EXITO: false,
              MENSAJE: error.message.toString(),
              RESPUESTA: null
            } as RespuestaModel);
          });
    });
  }

}
